export enum ERedirectDB {
  SESSION_DETAILS = 'showSessionDetails',
  WORKSHOP_REGISTRANTS = 'showWorkshopRegistrants',
  WORKSHOP_CHILD_CARE_REQUIREMENTS = 'showWorkshopChildcareRequirements',
  EVENT_REGISTRANTS = 'showEventRegistrants',
  EVENT_CHILD_CARE_REQUIREMENTS = 'showEventChildcareRequirements',
}

export enum ERedirectUI {
  SESSION_DETAILS = 'showSessionDetails',
  WORKSHOP_REGISTRANTS = 'showWorkshopRegistrants',
  WORKSHOP_CHILD_CARE_REQUIREMENTS = 'showWorkshopChildcareRequirements',
  EVENT_REGISTRANTS = 'showEventRegistrants',
  EVENT_CHILD_CARE_REQUIREMENTS = 'showEventChildcareRequirements',
}
